function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import echarts from 'echarts';
import { index_PV_UV, index_channel_list, index_line_data } from "@/request/api.admin/index";
export default {
  name: '',
  data: function data() {
    return {
      loadingData: false,
      showPicker: false,
      time: '',
      params: {
        period: 'today',
        dataType: 'uv',
        beginDate: "",
        endDate: ""
      },
      timeList: [{
        name: "今日",
        value: 'today'
      }, {
        name: "昨日",
        value: 'yesterday'
      }, {
        name: "近7日",
        value: 'sevenDays'
      }, {
        name: "本月",
        value: 'currentMonth'
      }, // {
      //   name: "上月",
      //   value: 'lastMonth'
      // },
      {
        name: "今年",
        value: 'thisYear'
      }, {
        name: "自定义",
        value: 'customize'
      }],
      dataType: [{
        name: "UV",
        value: 'uv'
      }, {
        name: "PV",
        value: "pv"
      }],
      PV_UV: {
        todayPv: 0,
        todayUv: 0,
        totalPv: 0,
        totalUv: 0
      },
      list: []
    };
  },
  created: function created() {
    this.getPU();
    this.getList();
    this.getLineData();
  },
  watch: {
    time: function time(n, o) {
      if (!n) {
        this.params['beginDate'] = '';
        this.params['endDate'] = '';
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    onPeriodChange: function onPeriodChange(value) {
      this.params['period'] = value;

      if (value == 'customize') {
        this.showPicker = true;
      } else {
        this.time = '';
        this.showPicker = false;
        this.getLineData();
      }
    },
    onDataTypeChange: function onDataTypeChange(value) {
      this.params['dataType'] = value;

      if (this.params['period'] === 'customize' && !this.time) {
        this.$message.closeAll();
        this.$message({
          message: '请先选择查询时间段',
          type: 'warning',
          duration: 1500
        });
        return;
      }

      this.getLineData();
    },
    onTimeChange: function onTimeChange(arr) {
      if (arr) {
        this.params['beginDate'] = arr[0];
        this.params['endDate'] = arr[1];
        this.getLineData();
      }
    },
    // 获取PV UV
    getPU: function getPU() {
      var _this = this;

      index_PV_UV().then(function (res) {
        // console.log('获取PV UV', res)
        if (res.code === 0) {
          for (var key in _this.PV_UV) {
            _this.PV_UV[key] = res['data'][key];
          }
        }
      });
    },
    // 获取渠道列表
    getList: function getList() {
      var _this2 = this;

      index_channel_list().then(function (res) {
        // console.log('获取渠道列表', res)
        if (res.code === 0) {
          _this2.list = res.data;
        }
      });
    },
    // 折线图
    getLineData: function getLineData() {
      var _this3 = this;

      this.loadingData = true;
      index_line_data(this.params).then(function (res) {
        // console.log('折线图', res)
        if (res.code !== 0) {
          return;
        }

        var data = res.data; // console.log(data)

        var list = new Array();

        for (var key in data) {
          var obj = new Object();
          var x = new Array();
          var y = new Array();
          obj['title'] = key;

          var _iterator = _createForOfIteratorHelper(data[key]),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;

              for (var el in item) {
                el === 'sum' ? y.push(item[el]) : x.push(item[el]);
              }

              obj['xAxis'] = x;
              obj['data'] = y;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          list.push(obj);
        } // console.log(list)


        var legend = new Array();
        var xAxis = new Array();
        var series = new Array();

        for (var _i = 0, _list = list; _i < _list.length; _i++) {
          var _item = _list[_i];
          legend.push(_item['title']);
          xAxis = _item.xAxis;
          var _obj = {
            name: _item['title'],
            type: 'line',
            // stack: '访问量',
            // areaStyle: {},
            data: _item.data
          };
          series.push(_obj);
        }

        _this3.drawLine({
          legend: legend,
          xAxis: xAxis,
          series: series
        });
      }).then(function () {
        _this3.loadingData = false;
      });
    },
    drawLine: function drawLine(_ref) {
      var legend = _ref.legend,
          xAxis = _ref.xAxis,
          series = _ref.series;
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(this.$refs.echarts); // 绘制图表

      myChart.setOption({
        title: {
          text: '各页面访问次数'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: legend
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: xAxis
        }],
        yAxis: [{
          type: 'value'
        }],
        series: series
      });
    }
  }
};